export type QrDownloadFormat = 'png' | 'svg' | 'pdf';

export type QrImageFormat = 'png' | 'svg';

export interface QrFormatOption {
  format: QrDownloadFormat;
  label: string;
  description: string;
}

export const QR_FORMAT_OPTIONS: QrFormatOption[] = [
  { format: 'png', label: 'PNG', description: 'Recommended · works everywhere' },
  { format: 'svg', label: 'SVG', description: 'Vector · Illustrator, Canva' },
  { format: 'pdf', label: 'PDF', description: 'Print-ready · opens print dialog' },
];

export const QR_IMAGE_FORMAT_OPTIONS: QrFormatOption[] = QR_FORMAT_OPTIONS.filter(option => option.format !== 'pdf');

const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
const XML_PROLOG = '<?xml version="1.0" encoding="UTF-8"?>';

export function qrImageMimeType(format: QrImageFormat): string {
  return format === 'png' ? 'image/png' : 'image/svg+xml';
}

export function qrDownloadFileName(eventUrl: string, format: QrImageFormat): string {
  return `votebeats-${eventUrl}-qr.${format}`;
}

export function serializeSvg(svgElement: SVGSVGElement): string {
  let markup = new XMLSerializer().serializeToString(svgElement);
  if (!/^<svg[^>]*\sxmlns="/.test(markup)) {
    markup = markup.replace(/^<svg/, `<svg xmlns="${SVG_NAMESPACE}"`);
  }
  return `${XML_PROLOG}\n${markup}`;
}

export function canvasToPngBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error('Canvas produced no PNG data'));
    }, 'image/png');
  });
}

export function triggerFileDownload(blob: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(url);
}
